import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "3fad28c9-652b-4d6a-bbff-6695de5fc145", content: "Required number is equal for both designs.", options: {} },
  { id: "ade84b10-ce3b-4320-a1dd-a5135aa2b371", content: "Within-subject design.", options: {} },
  { id: "6eade219-24ca-4bf3-8f18-29cb061cc193", content: "Between-subject design.", options: {} },
  { id: "4f40ae7a-f355-410b-b470-e754b8139cc1", content: "Depends on the power analysis.", options: {} },
];

export const task: Task = {
  id: "368841cd-104b-4e26-b7d9-d719b18799ed",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6eade219-24ca-4bf3-8f18-29cb061cc193"],
};
